import React from 'react';
import { SkeletonBlock, SkeletonRow, SkeletonStack } from 'src/components/widgets/skeleton';
import { HeaderActions, Page, TopBar, Workspace } from './aiBulkStyles';
import { WizardArea, WizardForm } from './importWizard';

export const AIBulkPageSkeleton = () => (
    <Page aria-hidden='true'>
        <TopBar>
            <SkeletonRow $gap='12px'>
                <SkeletonBlock $width='38px' $height='38px' $radius='12px' />
                <SkeletonStack $gap='6px'>
                    <SkeletonBlock $width='100px' $height='18px' />
                    <SkeletonBlock $width='90px' $height='12px' />
                </SkeletonStack>
            </SkeletonRow>
            <HeaderActions>
                <SkeletonBlock $width='120px' $height='34px' $radius='8px' />
                <SkeletonBlock $width='36px' $height='36px' $round />
            </HeaderActions>
        </TopBar>
        <Workspace>
            <WizardArea>
                <WizardForm as='div'>
                    <SkeletonBlock $width='75%' $height='36px' />
                    <SkeletonBlock $height='128px' $radius='8px' />
                    <SkeletonBlock $height='112px' $radius='12px' />
                    <SkeletonRow $justify='flex-end'>
                        <SkeletonBlock $width='200px' $height='40px' $radius='8px' />
                    </SkeletonRow>
                </WizardForm>
            </WizardArea>
        </Workspace>
    </Page>
);
